import { useEffect } from 'react';
import { events } from 'gw-platform-events-js';
import CommonConstants from 'sg-common-constants';
import { publish } from '@jutro/events';
import SgScrollUtil from 'sg-scroll-util';
import { ADOBE_TOPICS, COMMON_TAGGING_PROPERTIES } from '../sg-adobe-analytics';

function useSgFieldErrorHandling() {
    const scrollToError = () => {
        setTimeout(() => {
            const firstError = document.querySelector('[class*="FieldMessage_error"]');
            if (firstError) {
                const closestField = firstError.closest('[class*="fieldComponent"]');
                if (closestField) {
                    SgScrollUtil.scrollToElementTop(closestField);
                } else {
                    SgScrollUtil.scrollToElementBottom(firstError);
                }
            }
        }, 0);
    };

    const publishErrorAnalytics = () => {
        const errorsList = document.querySelectorAll('[class*="FieldMessage_error"]');
        const errorIdArray = [];
        const errorMessageArray = [];
        for (let i = 0; i < errorsList.length; i += 1) {
            const parentAccordion = errorsList[i].closest('[aria-expanded]');
            const parentModal = errorsList[i].closest('[aria-modal]');
            if ((parentAccordion && parentAccordion.ariaExpanded === 'true') || (parentModal && parentModal.ariaModal === 'true')) {
                let fieldId = errorsList[i].id;
                fieldId = fieldId.substring(0, fieldId.indexOf('_'));
                const errorMessage = `${fieldId} - ${errorsList[i].innerText}`;
                errorIdArray.push(fieldId);
                errorMessageArray.push(errorMessage);
            }
        }
        publish(ADOBE_TOPICS.QUOTE_FIELD_ERROR, {
            adobeID: { quoteFieldError: COMMON_TAGGING_PROPERTIES.quoteFieldError, fieldErrorArray: COMMON_TAGGING_PROPERTIES.fieldErrorArray.id },
            idArray: errorIdArray,
            messagesArray: errorMessageArray
        });
    };

    const handleFieldErrors = () => {
        scrollToError();
        setTimeout(() => {
            publishErrorAnalytics();
        });
    };

    useEffect(() => {
        events.on(CommonConstants.SHOW_VALIDATION_ERROR_EVENT, handleFieldErrors);
        return () => {
            events.removeListener(CommonConstants.SHOW_VALIDATION_ERROR_EVENT, handleFieldErrors);
        };
    }, []);
}

export default useSgFieldErrorHandling;
